import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { RfqQuoteDetailsPageContext } from "@insite/content-library/Pages/RfqQuoteDetailsPage";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    quoteState: getQuoteState(state, state.pages.rfqQuoteDetails.quoteId),
    expirationDate: state.pages.rfqQuoteDetails.expirationDate,
    expirationDateError: state.pages.rfqQuoteDetails.expirationDateError,
    quoteSettings: getSettingsCollection(state).quoteSettings,
});
export interface RfqQuoteDetailsBillingAddressGridStyles {
    detailsGridContainer?: GridContainerProps;
    expirationDateGridItem?: GridItemProps;   
   
}
type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface RfqQuoteDetailBillingAddressGridStyles {
    titleText?: TypographyProps;
    addressDisplay?: AddressInfoDisplayStyles;
    wrapper?: InjectableCss;
}

export const rfqQuoteDetailsBillingAddressGridStyles: RfqQuoteDetailBillingAddressGridStyles = {
    wrapper: {
        css: css`
            padding-bottom: .625rem;

            address {
                color: ${themeColors.colorCharcoalGrey};
                font-family: 'Lato',sans-serif;
                font-size: ${themeFontSizes.size14};
                letter-spacing: 0.44px;
                line-height: 1.5rem;
                margin-top: 15px;

                p {
                    color: ${themeColors.colorCharcoalGrey};
                    font-family: 'Lato',sans-serif;
                    font-size: ${themeFontSizes.size14};
                    letter-spacing: 0.44px;
                }
            }
        `,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            @media print {
                font-size: .75rem;
            }
            margin-bottom: .31250625rem;
            color: #002554;
            font-family: 'Roboto', sans-serif;
            font-size: 1rem;
            font-weight: ${themeFontWeights.fontWeightForBold};
            letter-spacing: 0;
            line-height: 1.4375rem;
        `,
    },

};

const styles = rfqQuoteDetailsBillingAddressGridStyles;

const RfqQuoteDetailBillingAddress = ({
    quoteState,
    expirationDate,
    expirationDateError,
    quoteSettings,
}: Props) => {
    const quote = quoteState.value;
    if (!quote) {
        return null;
    } 
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText}>{translate('Billing Information')}</Typography>
            <AddressInfoDisplay
                firstName={quote.billTo?.firstName}
                lastName={quote.billTo?.lastName}
                companyName={quote.billTo?.companyName}
                address1={quote.billTo?.address1 ?? ""}
                address2={quote.billTo?.address2}
                address3={quote.billTo?.address3}
                address4={quote.billTo?.address4}
                city={quote.billTo?.city ?? ""}
                state={quote.billTo?.state?.abbreviation}
                postalCode={quote.billTo?.postalCode ?? ""}
                country={quote.billTo?.country?.abbreviation}
                extendedStyles={styles.addressDisplay}
            />
        </StyledWrapper>
    );
};


const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RfqQuoteDetailBillingAddress),
    definition: {
        displayName: "Quote Detail Billing Address",
        fieldDefinitions: [],
        group: "RFQ Quote Details",
    },
};

export default widgetModule;
